import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Checkup from "../../components/checkup"
import { Link } from "gatsby"
import trafikArtis from "../../assets/img/traffic-up-robesnmore.png"
import sorunlar from "../../assets/img/robesnmore-right.png"
import cozum from "../../assets/img/robesnmore-left.png"
import tasarim from "../../assets/img/robesnmore-info.png"

import bilgione from "../../assets/img/robesnmore-detail.png"
import desingpc from "../../assets/img/design-pc-4.png"
import desingpctwo from "../../assets/img/design-pc-5.png"



const ReferancesDetail = () => (
    <Layout>
        <SEO title="robesNmore Success Story" 
        description="Click to check out the success story we have achieved with robesNmore, which we have been providing digital marketing solutions since 2019."
        />
        <div className="referances-detail py60 container news">
            <div className="col-md-6 detail-left">
                <b>SUCCESS STORY</b>
                
                <h1 style={{ marginTop: 20 }}>RobesNmore</h1>
                <p style={{ maxWidth: 500 }}>robesNmore is a family-owned company located in California, specializing in importing, manufacturing, and wholesale towels, bathrobes, and other linens. They decided to invest in a digital marketing strategy to increase organic traffic and sales of their e-commerce store in 2019.</p>
                <div className="col-md-6 referances-boxs news">
               <div className="boxs" style={{ marginBottom: '0' }}>
                    <div className="box">
                        <span>+132%</span>
                        <p>Organic Session!</p>
                    </div>
                    <div className="box">
                        <span>+44%</span>
                        <p>New Users</p>
                    </div>
                    <div className="box">
                        <span>+22%</span>
                        <p>Shopping Conversion</p>
                    </div>

                </div>
                </div>
                
            </div>
            <div className="col-md-6 referances-boxs">
               
                <div className="provided">
                    <h3>Services Provided</h3>
                    <div className="provided-box news">
                        <div className="box" >
                        <Link to="/search-engine-optimization/"></Link>
                            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 100 100" >
                      <g id="Icons-_-Shopping-_-Chart-line_1" data-name="Icons-/-Shopping-/-Chart-line#1" transform="translate(0 0.249)">
                        <rect id="bound" width="100" height="100" transform="translate(0 -0.249)" fill="none" />
                        <path id="Path-95" d="M11.261,69.088H73.219a4.131,4.131,0,0,1,0,8.261H7.131A4.131,4.131,0,0,1,3,73.219V7.131a4.131,4.131,0,1,1,8.261,0Z" transform="translate(9.392 9.392)" fill="#111111" />
                        <path id="Path-97" d="M14.144,40.3a4.131,4.131,0,0,1-6.027-5.65L23.607,18.132a4.131,4.131,0,0,1,5.695-.317L41.526,28.247,57.455,8.071a4.131,4.131,0,1,1,6.484,5.119L45.351,36.734a4.131,4.131,0,0,1-5.923.583L26.937,26.658Z" transform="translate(21.914 20.348)" fill="#111111" opacity="0.3" />
                      </g>
                    </svg>  
                     SEO
                        </div>
                        <div className="box" >
                        <Link to="/digital-ads/"></Link>
                            <svg id="Icons-_-Shopping-_-Cart_1" data-name="Icons-/-Shopping-/-Cart#1" xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 95 95">
                      <rect id="bound" width="95" height="95" fill="none" />
                      <path id="Combined-Shape" d="M65.116,38.389,62.355,54.954l-.01.057a3.958,3.958,0,0,1-4.6,3.186l-45-8.182a3.958,3.958,0,0,1-3.1-2.807L2.419,21.928a3.958,3.958,0,0,1,3.806-5.046H60.557l2.427-10.4a4.671,4.671,0,0,1,4.548-3.609h8.173a4.671,4.671,0,1,1,0,9.341H71.239Z" transform="translate(6.707 8.493)" fill-rule="evenodd" opacity="0.3" />
                      <path id="Combined-Shape-2" data-name="Combined-Shape" d="M10.937,29.875a5.938,5.938,0,1,1,5.938-5.937A5.938,5.938,0,0,1,10.937,29.875Zm35.625,0A5.938,5.938,0,1,1,52.5,23.938,5.938,5.938,0,0,1,46.562,29.875Z" transform="translate(14.792 53.25)" fill-rule="evenodd" />
                    </svg>
                       Digital Ads
                        </div>
                        <div className="box" >
                        <Link to="/content-marketing/"></Link>
                            <svg id="katman_1" xmlns="http://www.w3.org/2000/svg" width="50" height="50" style={{fill: 999, marginLeft: 4}}  viewBox="0 0 100 100"><path id="Combined-Shape"  d="M62.41,94.64h-26.76c-1.33,0-.94,0-1.81-.01-5.49-.14-6.93-.43-10.42-1.21-7.32-1.8-12.76-5.97-16.01-12.84-2-4.25-2.54-8.82-2.69-13.45-.32-9.66-.2-19.31-.13-28.97,.03-4.05,.09-8.12,.83-12.13,1.14-6.2,3.98-11.4,9.07-15.22,4.36-3.27,9.41-4.55,14.75-4.97,2.04-.16,3.35-.25,6.11-.31,.19,0,.38-.04,.58-.04h26.3c.93,.03,.98,0,1.57,0,3.09,.04,6.13,.18,9.18,.74,7.1,1.3,12.73,4.91,16.51,11.18,2.4,3.98,3.61,8.27,3.93,12.86,.02,.55,.05,.8,.08,1.5v35.87c-.03,.56-.05,.61-.06,.93-.07,1.8-.5,3.57-.82,5.34-.96,5.33-3.17,10.02-7.17,13.77-4.71,4.42-10.47,6.15-16.75,6.62-2.23,.21-3.85,.26-6.31,.34h0Zm-13.36-8.02c2.35,0,4.69,.03,7.04,0,5.03-.06,10.09,.1,15.08-.69,6.55-1.04,11.07-4.59,13.06-11.06,.91-2.97,1.01-6.05,1.12-9.12,.27-7.89,.19-15.78,.14-23.68-.03-4.7,.02-9.4-.66-14.07-1.03-7.14-5.43-11.89-12.43-13.47-3.1-.7-6.26-.75-9.41-.81-7.76-.16-15.52-.15-23.28-.06-4.46,.05-8.92-.04-13.34,.74-6.75,1.19-11.26,5.5-12.81,12.19-.68,2.93-.74,5.92-.83,8.91-.2,7.17-.19,14.33-.12,21.5,.05,5.02-.07,10.05,.64,15.03,.66,4.61,2.59,8.52,6.52,11.23,3.03,2.09,6.5,2.81,10.09,3.05,6.39,.42,12.79,.34,19.19,.34h0Z"/><g><path id="Combined-Shape"  class="cls-1" d="M50.05,52.09c-7.47,0-14.94,0-22.41,0-2.45,0-4.07-2.15-3.33-4.37,.42-1.26,1.57-2.16,2.9-2.26,.16-.01,.33,0,.5,0h44.65c1.65,0,2.89,.81,3.39,2.17,.8,2.2-.8,4.45-3.21,4.46-4.04,.02-8.08,0-12.12,0h-10.37Z"/><path id="Combined-Shape"  class="cls-1" d="M57.4,38.8c-5.03,0-10.07,.01-15.1,0-2.37,0-3.95-2.21-3.21-4.4,.47-1.37,1.71-2.23,3.26-2.23,3.62,0,7.25,0,10.87,0,6.42,0,12.83,0,19.25,0,2.43,0,4.05,2.18,3.29,4.4-.47,1.39-1.72,2.24-3.34,2.24-5.01,0-10.01,0-15.02,0h0Z"/><path id="Combined-Shape"  class="cls-1" d="M60.92,64.87c-3.97,0-7.93,.01-11.89,0-1.87,0-3.11-2-2.53-3.98,.37-1.24,1.34-2.02,2.56-2.02,2.85,0,5.71,0,8.56,0,5.05,0,10.11,0,15.16,0,1.92,0,3.19,1.98,2.59,3.98-.37,1.25-1.36,2.02-2.63,2.02-3.94,0-7.89,0-11.83,0h0Z"/><path id="Combined-Shape"  class="cls-1" d="M33.51,58.73c1.91,0,3.81,0,5.72,0,2.02,.01,3.49,1.42,3.49,3.32s-1.48,3.31-3.49,3.32c-3.87,0-7.74,0-11.61,0-2.02,0-3.49-1.43-3.49-3.32,0-1.9,1.48-3.31,3.49-3.32,1.96,0,3.92,0,5.89,0h0Z"/><path id="Combined-Shape"  d="M28.3,39.29c-2.3,0-4.17-1.85-4.17-4.15,0-2.3,1.87-4.16,4.17-4.15,2.26,0,4.11,1.85,4.13,4.11,.02,2.3-1.84,4.18-4.13,4.19h0Z"/></g></svg>
                            Content Marketing  
                        </div>
                    </div>
                </div>
                <div className="project-details">
                    <h3>Impressum</h3>
                    <div className="project-details_list">
                        <ul>
                            <li>Brand Manager:</li>
                            <li>Digital Ads:</li>
                            <li>SEO Manager:</li>
                            <li>Web Developer</li>
                            <li>Content Creator:</li>
                        </ul>
                        <ul>
                            <li>Rana Temiz</li>
                            <li>Erman Yaman</li>
                            <li>Emel Elbeyoğlu</li>
                            <li>Serkan Sarıçiçek</li>
                            <li>Tugay Demir</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div className="container">
        <div className="text-center content news">
                <h2 style={{ marginTop: 7 }}>+132% Increase in Organic <br/>Sessions Thanks to SEO Services</h2>
                <p style={{margin: '10px auto 0' }}>robesNmore has experienced a significant increase in organic traffic with the right SEO strategy implemented. Within 2 years, their website's organic traffic increased by 132%. There is also a significant improvement in search engine rankings for their target keywords.</p>
                <p style={{margin: '10px auto 0' }}>By identifying target keywords, creating well-optimized high-quality content, and internal linking within this content, authentic blog content was produced for the website.</p>
                <img className="robesnmore" src={bilgione} alt="robesnMore"/>
                <p style={{margin: '30px auto 0' }}>Thanks to the content produced and developed, there was a 317% increase in pageview after we started our service.</p>
                <p style={{margin: '10px auto 0' }}>With content marketing and link building, we achieved first-page targets in targeted keywords within the first 2 years. </p>

            </div>
            </div>

        <div className="container">
            <div className="content-section content row py60" >
                <div className="col-md-6">
                    <img className="pr100" src={cozum} alt="robesnMore"/>
                </div>
                <div className="col-md-6">
                    <span className="small">Success Sory</span>
                    <h3>Position changes in Target Keywords </h3>
                    <p style={{ maxWidth: 429 }} >"Wholesale Robes" from 10th to 2nd place</p>
                    <p style={{ maxWidth: 429 }} >"Spa Robes Wholesale" from 34th to 3rd place</p>
                    <p style={{ maxWidth: 429 }} >"Wholesale Bathrobes" from 12th to 3rd place</p>
                    <p style={{ maxWidth: 429 }} >"Waffle Robes Wholesale" from 10th to 1st place</p>
                </div>
            </div>
            <div className="content-section content row" id="eCantaCozum">
                <div className="col-md-6">
                    <span className="small">Success Story</span>
                    <h3>344% Increase in Organic Traffic Generating Keywords</h3>
                    <p style={{ maxWidth: 429 }}>In addition to all that, we managed to increase the number of keywords with organic traffic generation from 900 to 4,000 with an increase of 344% since the day we started our operations.</p>
                    <p style={{ maxWidth: 429 }} className="small">We also conducted an on-page audit of their website to identify and fix technical issues that may have hindered search engine visibility. We fixed broken links and improved the site's navigation structure to suit the user experience better. </p>
                    <p style={{ maxWidth: 429 }} className="small">Overall, robesnMore has been successful in increasing their website's organic traffic and sales with the right SEO strategy and they continue to invest in our SEO operations as an essential part of their digital marketing strategy.</p>
                </div>
                <div className="col-md-6">
                    <img src={sorunlar} alt="robesnMore"/>
                </div>
            </div>

            <div className="text-center content py60">
                <span className="small">Success Sory</span>
                <h2 style={{ margin: '7px auto 50px', maxWidth: 1500 }}>44% Increase in New Users and 22% Increase in Shopping Conversion with the Right Ad Optimizations!</h2>
                
            </div>
            

            

            <div className="content-section content row" id="eCantaCozum">
            <div className="col-md-6">
                    <img src={trafikArtis} alt="iki laptop bilgisayar ekranında tcdd taşımacılık web sitesi görüntüleniyor" />
                </div>
                <div className="col-md-6">
                    <p style={{ maxWidth: 429, fontSize: 20}} className="small news">robesNmore has achieved an increase in online sales and a higher conversion rate over time thanks to search ads and continues to invest in this field!  As a result of this investment, we have experienced a 44% increase in new user acquisition with Generic Paid Search ads, a 22% increase in shopping conversion, and a 68% increase in revenue over a 2-year period!</p>
                </div>
                <img src={tasarim} style={{ width: '100%', marginTop:40, marginBottom:40 }} />

            </div>

            <div className="content-section content row" id="eCantaCozum">
            
                <div className="col-md-6">
                    <p style={{ maxWidth: 500, fontSize: 20 }} className="small news">First, we conducted keyword research to identify relevant and high-traffic keywords related to the brand's products and analyzed competitors in the industry to determine the advertising strategy.</p>
                </div>
                <div className="col-md-6">
                    <img src={desingpc} alt="iki laptop bilgisayar ekranında tcdd taşımacılık web sitesi görüntüleniyor" />
                </div>
            </div>
            <div className="content-section content row" id="eCantaCozum">
            <div className="col-md-6">
                <img src={desingpctwo} alt="iki laptop bilgisayar ekranında tcdd taşımacılık web sitesi görüntüleniyor" />
            </div>
            <div className="col-md-6">
                <p style={{ maxWidth: 500, fontSize: 20 }} className="small news">Based on our research, a series of search ads were created with different campaign sets. We specifically addressed the ads to specific geographic locations and demographics that our brand is targeting to sell to. Competitors' campaigns were analyzed and the landing page was redesigned with an emphasis on pricing communication in support of the ad.</p>
            </div>
            
        </div>

        </div>


        <Checkup />
    </Layout >
)

export default ReferancesDetail
